import { extendTheme } from '@chakra-ui/react';
import '@fontsource/viga';
import '@fontsource/righteous';
import '@fontsource/roboto-mono';
import '@fontsource/roboto-mono/400.css';
import '@fontsource/inter';
import '@fontsource/inter/300.css'; // Weight 300
import '@fontsource/inter/400.css'; // Weight 400
import '@fontsource/inter/500.css'; // Weight 500
import '@fontsource/inter/600.css'; // Weight 600
import '@fontsource/inter/700.css'; // Weight 700
import '@fontsource/inter/400-italic.css'; // Weight 400 Italic
import '@fontsource/inter/700-italic.css'; // Weight 700 Italic

const theme = extendTheme({
  fonts: {
    heading: 'Inter, sans-serif',
    body: 'Inter, sans-serif',
    mono: '"Roboto Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
  },
  styles: {
    global: {
      'html': {
        scrollBehavior: 'smooth',
      },
      'html, body': {
        fontFamily: 'Inter, sans-serif',
        fontWeight: 'normal',
        backgroundColor: 'black',
        color: 'white',
        WebkitFontSmoothing: 'antialiased',
      },
      'b, strong': {
        fontFamily: 'Inter, sans-serif',
        fontWeight: 'bold',
      },
      'em, i': {
        fontFamily: 'Inter, sans-serif',
        fontStyle: 'italic',
      },
      // Active nav link, driven by react-scroll's spy in Home4.
      '.nav-link-active': {
        color: 'white',
        opacity: 1,
      },
    },
  },
});

export default theme;
